module.exports = __webpack_public_path__ + "media/images/flags/64/Nagorno-Karabakh-213a6b35d068d8c69e2167994d113837.png";